import { render, staticRenderFns } from "./FuncMessage.vue?vue&type=template&id=f6151192&scoped=true&functional=true&"
import script from "./FuncMessage.vue?vue&type=script&lang=js&"
export * from "./FuncMessage.vue?vue&type=script&lang=js&"
import style0 from "./FuncMessage.vue?vue&type=style&index=0&id=f6151192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f6151192",
  null
  
)

export default component.exports